import styled, {css} from 'styled-components';
import {device} from 'styled/device';
import {Link} from 'react-router-dom';

export type NavigationStatusTextProps = {
  $completed: boolean;
};

export const GuestContainer = styled.div`
  padding: 0;
  width: 280px;
  background: #ffffff;
  border-radius: 12px;

  @media (min-width: ${device.tablet}) {
    width: 416px;
    max-width: 580px;
    margin: 0 auto;
  }
`;

const getItemStyles = (props: NavigationStatusTextProps) => css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  padding: 15px 18px 15px;

  &:last-child {
    border-bottom: none;
  }
  ${!props.$completed &&
  css`
    cursor: pointer;
  `}
`;

export const Item = styled.div<NavigationStatusTextProps>`
  ${props => getItemStyles(props)};
`;

export const LinkItem = styled(Link)<NavigationStatusTextProps>`
  ${props => getItemStyles(props)};
  cursor: pointer;
`;

export const Icon = styled.img``;

export const Texts = styled.div`
  display: block;
`;

export const Title = styled.div`
  display: block;
  width: 100%;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #152946;
`;

export const StatusText = styled.div<NavigationStatusTextProps>`
  display: flex;
  width: 100%;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #ffb27d;
  user-select: none;

  ${props =>
    props.$completed &&
    css`
      color: #32d7be;
    `}
`;

export const DeleteGuestIcon = styled.img`
  cursor: pointer;
`;

export const StatusIcon = styled.img`
  margin-right: 6px;
`;
